import * as Bixby from '$/core';

export abstract class ClientAnalyticsService {
  private static baseUrl = Bixby.Constants.API_ANALYTICSCONTROLLER;

  // Client
  public static async getCompanyAnalytics(): Promise<Bixby.Models.CompanyAnalyticsResult> {
    const route = Bixby.API.ServerRoute.forAction(
      `${ClientAnalyticsService.baseUrl}/${Bixby.Constants.API_ACTION_ANALYTICS_COMPANY}`
    );
    return await Bixby.API.get(route);
  }

  public static async getMarketDataAnalytics(): Promise<Bixby.Models.CompanyAnalyticsResult> {
    const route = Bixby.API.ServerRoute.forAction(
      `${ClientAnalyticsService.baseUrl}/${Bixby.Constants.API_ACTION_ANALYTICS_MARKETDATA}`
    );
    return await Bixby.API.get(route);
  }

  public static async getIndustryGroupAnalytics(industryGroupId: string): Promise<Bixby.Models.CompanyAnalyticsResult> {
    const route = Bixby.API.ServerRoute.forAction(
      `${ClientAnalyticsService.baseUrl}/${Bixby.Constants.API_INDUSTRYGROUPCONTROLLER}/${industryGroupId}`
    );
    return await Bixby.API.get(route);
  }
}
